import React, { useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { useMutation } from '@apollo/client';
import { Button, AlertService, ExportIcon } from '@spoiler-alert/ui-library';
import { DeletePosts } from '../../graphql/mutations';

const useStyles = createUseStyles({
  inputHidden: {
    display: 'none',
  },
  buttonBar: {
    display: 'flex',
    alignItems: 'center',
  },
  primaryButton: {
    marginRight: 10,
  },
});

const DeletePostsWidget = () => {
  const classes = useStyles();
  const fileInput = useRef();
  const [deletePosts, { loading }] = useMutation(DeletePosts);

  const handleDeletePosts = (ids) => {
    deletePosts({
      variables: { ids },
    })
      .then((response) => {
        fileInput.current.value = null;
        if (response.data.deletePosts.errors && response.data.deletePosts.errors.length) {
          AlertService.alert({
            type: 'warning',
            autoDismiss: true,
            message: <span>{response.data.deletePosts.errors[0].message}</span>,
          });
        } else
          AlertService.alert({
            type: 'success',
            message: <span>{'posts have successfully been deleted!'}</span>,
            autoDismiss: true,
            dismissDelay: 3000,
          });
      })
      .catch(() =>
        AlertService.alert({
          type: 'warning',
          autoDismiss: true,
          message: <span>Something went wrong with the post deletion.</span>,
        }),
      );
  };

  const readFile = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const ids = reader.result.split(/\r?\n/).map((row) => {
        return row.split(',')[0];
      });
      handleDeletePosts(ids);
    };
    reader.onerror = (err) => {
      AlertService.alert({
        type: 'warning',
        autoDismiss: true,
        message: <span>{`Something went wrong with reading the file.  Err: ${err.message}`}</span>,
      });
    };
    reader.readAsText(file);
  };

  const handleBrowseFilesClick = (ev) => {
    ev.preventDefault();
    fileInput.current.click();
  };

  const handleFileChange = (ev) => {
    readFile(ev.target.files[0]);
  };

  return (
    <div>
      <h4>Delete Posts</h4>
      <p>(CSV format, no header)</p>
      <div className={classes.buttonBar}>
        <Button
          className={classes.primaryButton}
          icon={ExportIcon}
          onClick={handleBrowseFilesClick}
          loading={loading}
          loadingText="Uploading..."
          style={{ marginBottom: 8, marginTop: 8 }}
        >
          Upload Posts File
        </Button>
        <span className={classes.inputHidden}>
          <input type="file" ref={fileInput} onChange={handleFileChange} />
        </span>
      </div>
    </div>
  );
};

export default DeletePostsWidget;
